import styled, { css } from 'foundations-theming/utils';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { URANUS_LAYER } from 'foundations-components/transitional/constants';
import CommentModeCursorTooltip from './CommentModeCursorTooltip';
import { H5 } from 'foundations-components/transitional/components/H5';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CommentModeIndicatorSharedStyle = css(["position:fixed;background-color:", ";overflow:hidden;z-index:", ";"], ({
  theme
}) => theme.color['fill-brand-default'], URANUS_LAYER);
const TopIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__TopIndicator",
  componentId: "rwpdby-0"
})(["", " height:", ";width:100%;top:0;left:0;"], CommentModeIndicatorSharedStyle, ({
  theme
}) => theme.space['250']);
const BottomIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__BottomIndicator",
  componentId: "rwpdby-1"
})(["", " height:", ";width:100%;bottom:0;left:0;"], CommentModeIndicatorSharedStyle, ({
  theme
}) => theme.space['250']);
const LeftIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__LeftIndicator",
  componentId: "rwpdby-2"
})(["", " height:100%;width:", ";left:0;top:0;"], CommentModeIndicatorSharedStyle, ({
  theme
}) => theme.space['250']);
const RightIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__RightIndicator",
  componentId: "rwpdby-3"
})(["", " height:100%;width:", ";right:0;top:0;"], CommentModeIndicatorSharedStyle, ({
  theme
}) => theme.space['250']);
const ModeIndicator = styled.div.withConfig({
  displayName: "CommentModeIndicator__ModeIndicator",
  componentId: "rwpdby-4"
})(["", " right:0;top:0;border-bottom-left-radius:18px;"], CommentModeIndicatorSharedStyle);
function CommentModeIndicator({
  onCancel
}) {
  /* TODO:The class names in here are used for style overrides
  in the email-editor-ui. A more scalable solution should be
  implemented that does not rely on class names and does not break
  existing behavior.
  */
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TopIndicator, {
      className: "top-indicator"
    }), /*#__PURE__*/_jsx(BottomIndicator, {
      className: "bottom-indicator"
    }), /*#__PURE__*/_jsx(LeftIndicator, {
      className: "left-indicator"
    }), /*#__PURE__*/_jsx(RightIndicator, {
      className: "right-indicator"
    }), /*#__PURE__*/_jsx(ModeIndicator, {
      className: "comment-mode--indicator-button",
      "data-test-id": "comment-mode-indicator",
      children: /*#__PURE__*/_jsxs(Button, {
        onClick: onCancel,
        use: "unstyled",
        children: [/*#__PURE__*/_jsx(H5, {
          color: "text-core-on-fill-default",
          marginBlockStart: "600",
          marginInlineEnd: "1300",
          marginBlockEnd: "500",
          marginInlineStart: "700",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "collaborationSidebar.modals.commentMode.title"
          })
        }), /*#__PURE__*/_jsx(CloseButton, {
          size: "medium",
          color: "icon-interactive-on-fill-default",
          marginBlockStart: "100",
          marginInlineEnd: "100"
        })]
      })
    }), /*#__PURE__*/_jsx(CommentModeCursorTooltip, {
      portalClassnameWrapper: "comment-mode-cursor-tooltip"
    })]
  });
}
CommentModeIndicator.propTypes = {
  onCancel: PropTypes.func.isRequired
};
export default CommentModeIndicator;